var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgHelp = function SvgHelp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.756 13.368l.036 1.188h-1.44v-1.188c0-.684.468-1.26 1.116-1.404 1.956-.425 1.774-3.206-.036-3.492-1.176-.235-2.16.726-2.16 1.764h-1.44c0-2.083 1.918-3.562 3.852-3.204 3.277.595 3.547 5.523.072 6.336zM12 15.24a1.06 1.06 0 00-1.08 1.08c0 .612.468 1.08 1.08 1.08a1.06 1.06 0 001.08-1.08A1.06 1.06 0 0012 15.24zM21 12c0 4.968-4.032 9-9 9s-9-4.032-9-9 4.032-9 9-9 9 4.032 9 9zm-1.44 0A7.56 7.56 0 0012 4.44 7.56 7.56 0 004.44 12 7.56 7.56 0 0012 19.56 7.56 7.56 0 0019.56 12z"
  })));
};

export default SvgHelp;